import { AxiosRequestConfig } from 'axios';
import { merge } from 'lodash';
import queryString from 'query-string';

import { generateAuthHeaders } from '@src/factories';

import Client from './client';
import { Post } from './types';

type Response = {
  readonly result: 'SUCCESS' | 'ERROR';
  readonly status: number;
  readonly checkIns: Post[];
};

type QueryType =
  | 'FOLLOWING'
  | 'NEARBY'
  | 'USER'
  | 'HASHTAG'
  | 'BUSINESS'
  | 'ALL';

type SortType = 'LIKE' | 'DISTANCE' | 'DATE';

export default (
  accessToken: string,
  type: QueryType,
  sortType: SortType = 'DATE',
  offset: number = 0,
  limit: number = 20,
  config?: AxiosRequestConfig
) => {
  return Client.get<Response>(
    `/cs/v1/checkins/query?${queryString.stringify({
      type,
      sortType,
    })}`,
    merge(config, {
      ...generateAuthHeaders(accessToken),
      params: {
        offset,
        limit,
      },
    })
  );
};
